import 'react-app-polyfill/ie9';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import {Provider} from "react-redux";
import {store} from "./redux/Store";

// 动态设置根字体大小：随视口宽度连续等比缩放（设计稿宽 1920px，基准 50px）
// 替代 index.css 中的阶梯式媒体查询，兼容浏览器缩放（Ctrl+滚轮）时布局不偏移
(function setRootFontSize() {
    var DESIGN_WIDTH = 1920;
    var BASE_FONT_SIZE = 50;

    function setFontSize() {
        var clientWidth = document.documentElement.clientWidth || document.body.clientWidth;
        var fontSize = clientWidth / DESIGN_WIDTH * BASE_FONT_SIZE;
        document.documentElement.style.fontSize = fontSize + 'px';
    }

    setFontSize();
    window.addEventListener('resize', setFontSize);
})();

ReactDOM.render(
  // <React.StrictMode>
    <Provider store={store}>
        <App/>
    </Provider>,
  // </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
